var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"loading_container"},[_c('div',{ref:"progressBar",staticClass:"animation_box"})])])}
var staticRenderFns = []

export { render, staticRenderFns }